import { render, staticRenderFns } from "./ModattaDashboardFunnel.vue?vue&type=template&id=413f2180"
import script from "./ModattaDashboardFunnel.vue?vue&type=script&lang=js"
export * from "./ModattaDashboardFunnel.vue?vue&type=script&lang=js"
import style0 from "./ModattaDashboardFunnel.vue?vue&type=style&index=0&id=413f2180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports